import img18a from '../../../assets/gallery/18b/18b-01-HOME_movil.jpg';
import img18b from '../../../assets/gallery/18b/18b-02_movil.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "",
    pictureSrc: img18a,
    description: "2018",
    orientation: "v"
  },
  {
    id: 2,
    title: "",
    dimensions: "",
    pictureSrc: img18b,
    description: "2018",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/18b/data18b.js